import { Box, CircularProgress } from '@mui/material';

const OverLayLoader = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pt: '4rem',
        backgroundColor: 'var(--color-bg-overlay)',
      }}
    >
      <CircularProgress size={70} thickness={3} color="secondary" />
    </Box>
  );
};

export default OverLayLoader;
